import { Shop } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconShop12Line = createIcon(Shop, 12, "Line");
export const IconShop16Line = createIcon(Shop, 16, "Line");
export const IconShop20Line = createIcon(Shop, 20, "Line");
export const IconShop24Line = createIcon(Shop, 24, "Line");
export const IconShop32Line = createIcon(Shop, 32, "Line");
export const IconShop48Line = createIcon(Shop, 48, "Line");
export const IconShop64Line = createIcon(Shop, 64, "Line");
